// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';
import OrderDetailTemplateContainer from 'containers/order/OrderDetailTemplateContainer';

type Props = {};

class OrderDetail extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>주문 내역 | 캐시바이</title>
          </Helmet>
          <OrderDetailTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default OrderDetail;



// WEBPACK FOOTER //
// ./src/pages/OrderDetail.js